export var IdAssetBundleMarket;
(function (IdAssetBundleMarket) {
    IdAssetBundleMarket["Market_MainBack0"] = "Market_MainBack0";
    IdAssetBundleMarket["Market_MainBack1"] = "Market_MainBack1";
    IdAssetBundleMarket["Market_MainBack2"] = "Market_MainBack2";
    IdAssetBundleMarket["Market_MainBack3"] = "Market_MainBack3";
    IdAssetBundleMarket["Market_MainBack4"] = "Market_MainBack4";
    IdAssetBundleMarket["Market_MainBack5"] = "Market_MainBack5";
    IdAssetBundleMarket["Market_MainFront1"] = "Market_MainFront1";
    IdAssetBundleMarket["Market_MainFront2"] = "Market_MainFront2";
    IdAssetBundleMarket["Market_MainFront3"] = "Market_MainFront3";
    IdAssetBundleMarket["Market_MainFront4"] = "Market_MainFront4";
    IdAssetBundleMarket["Market_MainFront5"] = "Market_MainFront5";
    IdAssetBundleMarket["Market_FoodFront0"] = "Market_FoodFront0";
    IdAssetBundleMarket["Market_FoodFront1"] = "Market_FoodFront1";
    IdAssetBundleMarket["Market_FoodFront2"] = "Market_FoodFront2";
    IdAssetBundleMarket["Market_FoodFront3"] = "Market_FoodFront3";
    IdAssetBundleMarket["Market_FoodFront4"] = "Market_FoodFront4";
    IdAssetBundleMarket["Market_FoodFront5"] = "Market_FoodFront5";
    IdAssetBundleMarket["Market_FoodBack0"] = "Market_FoodBack0";
    IdAssetBundleMarket["Market_FoodBack1"] = "Market_FoodBack1";
    IdAssetBundleMarket["Market_FoodBack2"] = "Market_FoodBack2";
    IdAssetBundleMarket["Market_FoodBack3"] = "Market_FoodBack3";
    IdAssetBundleMarket["Market_FoodBack4"] = "Market_FoodBack4";
    IdAssetBundleMarket["Market_FlowerBack0"] = "Market_FlowerBack0";
    IdAssetBundleMarket["Market_FlowerBack4"] = "Market_FlowerBack4";
    IdAssetBundleMarket["Market_FlowerFront0"] = "Market_FlowerFront0";
    IdAssetBundleMarket["Market_FlowerFront5"] = "Market_FlowerFront5";
})(IdAssetBundleMarket || (IdAssetBundleMarket = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/outskirts/IdAssetBundleMarket.ts
// module id = 2140
// module chunks = 3